import { NgTemplateOutlet } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  ContentChild,
  Input,
  TemplateRef,
} from '@angular/core';

import { ButtonComponent } from '../../common/button/components/button/button.component';
import { DividerComponent } from '../../common/divider/divider.component';
import { HeadingComponent } from '../../common/heading/heading.component';
import { IconHelpComponent } from '../../common/icon-help/icon-help.component';
import { IconColorDirective } from '../../common/icon/directives/icon-color.directive';
import { IconComponent, IconSize } from '../../common/icon/icon.component';
import { TabsComponent } from '../../common/tabs/tabs.component';
import { RtTooltip } from '../../common/tooltip/tooltip.directive';
import { ComponentVariant, Variants } from '../../common/variant/variant';
import { IconName } from '../../icons-container/icons.type';

@Component({
  selector: 'rt-dialog-header',
  templateUrl: './dialog-header.component.html',
  styleUrls: ['./dialog-header.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.has-actions]': 'newButton || actionsSlot',
    '[class.has-tabs]': 'tabs',
    '[class.has-padding]': 'hasPadding',
    '[class.blue-bg]': 'hasBlueBg',
    '[class]': 'variant',
  },
  standalone: true,
  imports: [
    DividerComponent,
    HeadingComponent,
    IconColorDirective,
    IconComponent,
    IconHelpComponent,
    NgTemplateOutlet,
    RtTooltip,
  ],
})
export class DialogHeaderComponent {
  public static readonly VARIANTS: Variants = [
    'default',
    ['default', 'dark', 'no-padding', 'no-bottom-padding'],
  ];
  @ComponentVariant(DialogHeaderComponent.VARIANTS)
  @Input()
  public variant: string;
  @Input() public hasDivider: boolean = true;
  @Input() public heading: string;
  @Input() public subheading: string;
  @Input() public icon: IconName;
  @Input() public hint: string;
  @Input() public hasPadding: boolean = false;
  @Input() public hasBlueBg: boolean = false;
  @Input() public iconSize: IconSize = 'large-x';
  @Input() public iconMarginLeft: boolean = true;
  @Input() public actionsSlot: TemplateRef<any>;
  @Input() public badge: TemplateRef<any> | null = null;
  @Input() public stepText: string = '';

  @ContentChild(ButtonComponent)
  public newButton: ButtonComponent;

  @ContentChild(TabsComponent)
  public tabs: TabsComponent;
}
